import axios from 'axios'

export const USERGROUPS_HAS_ERROR = 'USERGROUPS_HAS_ERROR';
export const USERGROUPS_IS_LOADING = 'USERGROUPS_IS_LOADING';
export const USERGROUPS_FETCH_DATA_SUCCESS = 'USERGROUPS_FETCH_DATA_SUCCESS';
export const USERGROUPS_CREATE_CACHE = 'USERGROUPS_CREATE_CACHE';

export function usergroupsHasError(err) {
    return {
        type: USERGROUPS_HAS_ERROR,
        error: err
    };
}

export function usergroupsIsLoading(bool) {
    return {
        type: USERGROUPS_IS_LOADING,
        isLoading: bool
    };
}

export function usergroupsFetchDataSuccess(groups) {
    return {
        type: USERGROUPS_FETCH_DATA_SUCCESS,
        groups
    };
}

export function usersgroupsCreateCache(groups) {
    var groupsCache = groups.reduce(function(hash, value) {
        var key = value['id'];
        hash[key] = value.name;
        return hash;
      }, {});

    return {
        type: USERGROUPS_CREATE_CACHE,
        groupsCache
    };
}

async function getData() {
    const res = await axios("/group?sort=name");
    return res.data;
  }

export function fetchUserGroups() {
    return (dispatch) => {
        dispatch(usergroupsIsLoading(true));

        getData()
        .then(response => {
            dispatch(usergroupsIsLoading(false));
            dispatch(usergroupsFetchDataSuccess(response));
            dispatch(usersgroupsCreateCache(response));
        })
        .catch(err => 
        {
            dispatch(usergroupsHasError(err));
        })
        }
    }

